import { gsap } from "gsap"
import Toastify from 'toastify-js'
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin"
import { CountUp } from '../external/countUp';
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(DrawSVGPlugin);
export default {
  init() {

    $('[data-reveal]').on('closed.zf.reveal', function (event) {
      setTimeout(() => {
        var $if = $(event.delegateTarget).find('iframe');
        console.log($if);
        var src = $if.attr('src');
        console.log(src);
        $if.attr('src', '');
        $if.attr('src', src);
    }, 200)
    });

    $('.smooth, .smooth a').click(function() {
      if (location.pathname.replace(/^\//,'') === this.pathname.replace(/^\//,'') && location.hostname === this.hostname) {
        $('.top-bar').removeClass('open');
        var target = $(this.hash);
        target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
        if (target.length) {
          $('html,body').animate({scrollTop: target.offset().top}, 1000); // Set scroll speed here
          return false;
        }
      }
    });

    $('.no-link > a').on('click', function(event) {
      event.preventDefault();
    });

    $('.menu-icon').on('click', function(event) {
      $('.top-bar').toggleClass('open');
      $(this).toggleClass('menu-icon-open');
      setTimeout(function() {
        $('.title-bar').toggleClass('mob-open');
      }, 200);
      event.preventDefault();
    });

    $('.slick__logo_slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      autoplay: true,
      swipe: true,
      infinite: true,
      responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
      ],
    });

    $('.content_slider__list').each(function(){
      $(this).slick({
        slidesToShow: 1,
        centerMode: false,
        dots: true,
        arrows: true,
        autoplay: false,
        swipe: true,
        infinite: true,
        prevArrow: $(this).parent().find('.content_slider__prev'),
        nextArrow: $(this).parent().find('.content_slider__next'),
        appendDots: $(this).parent().find('.content_slider__pagination'),
      });
    });

    function countStart() {
      var $counters = document.querySelectorAll(".animate-number");

      $counters.forEach((item) => {
        if (item.classList.contains("has-decimal")) {
          var options = {
            useEasing: true,
            useGrouping: true,
            separator: ",",
            decimal: ".",
            decimalPlaces: 1,
          };
        } else {
          var options = {
            useEasing: true,
            useGrouping: true,
            separator: ",",
            decimalPlaces: 0,
          };
        }
      
        var value = item.dataset.value;
        var counter = new CountUp(item, value, options);
        counter.start();
      });
    }

    if (document.querySelector('.inner__stat_block')) {
      new Waypoint({
        element: document.querySelector(".inner__stat_block"),
        handler: function () {
          countStart();
        },
        offset: "75%",
      });
    }

    // Component Animations

    // Hero
    let heroArr = gsap.utils.toArray('.outer__basic_hero'); 
    heroArr.forEach((hero, i) => {
      let htl = gsap.timeline({
        scrollTrigger: {
          trigger: hero,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      htl.to(hero.querySelector('h1'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(hero.querySelectorAll('p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      .to(hero.querySelectorAll('a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
    });

    // Sizzle Hero
    let sizArr = gsap.utils.toArray('.outer__sizzle_hero'); 
    sizArr.forEach((siz, i) => {
      let siztl = gsap.timeline({
        scrollTrigger: {
          trigger: siz,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      siztl.to(siz.querySelector('h1'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(siz.querySelectorAll('p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      .to(siz.querySelectorAll('a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
    });

    // Logo Slider
    let logoArr = gsap.utils.toArray('.outer__logo_slider'); 
    logoArr.forEach((logo, i) => {
      let ltl = gsap.timeline({
        scrollTrigger: {
          trigger: logo,
          start: 'top +=80%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      ltl.to(logo.querySelector('.inner__logo_slider'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(logo.querySelectorAll('a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
    });

    // Content Blocks
    let cbArr = gsap.utils.toArray('.outer__content_blocks'); 
    cbArr.forEach((blk, i) => {
      let lotl = gsap.timeline({
        scrollTrigger: {
          trigger: blk,
          start: 'top +=70%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      lotl.to(blk.querySelector('.inner__content_blocks'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
    });

    // Content Slider
    let sbArr = gsap.utils.toArray('.outer__content_slider'); 
    sbArr.forEach((cs, i) => {
      let cstl = gsap.timeline({
        scrollTrigger: {
          trigger: cs,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      cstl.to(cs.querySelector('.inner__content_slider'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
    });

    // Content Slider
    /*
    let ctaArr = gsap.utils.toArray('.outer__cta_block'); 
    ctaArr.forEach((ct, i) => {
      let lotl = gsap.timeline({
        scrollTrigger: {
          trigger: ct,
          start: 'top +=0',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      lotl.to(ct.querySelector('.inner__cta_block'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
    });
    */

    // Demo Block
    let demoArr = gsap.utils.toArray('.demo-block'); 
    demoArr.forEach((db, i) => {
      let dbtl = gsap.timeline({
        scrollTrigger: {
          trigger: db,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      dbtl.to(db.querySelectorAll('.top h1'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      dbtl.to(db.querySelectorAll('.top p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      dbtl.to(db.querySelectorAll('.top ul'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      dbtl.to(db.querySelectorAll('.bottom'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      dbtl.to(db.querySelectorAll('.form-wrap h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      dbtl.to(db.querySelectorAll('.form-wrap p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
    });

    // Contact Block
    let contactArr = gsap.utils.toArray('.contact-block'); 
    contactArr.forEach((cb, i) => {
      let cbtl = gsap.timeline({
        scrollTrigger: {
          trigger: cb,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      cbtl.to(cb.querySelector('h1'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      cbtl.to(cb.querySelectorAll('p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      cbtl.to(cb.querySelector('.form-wrap'), {opacity: 1, duration: 1, ease: 'power4.out'}, '-=0.95')
      cbtl.to(cb.querySelectorAll('.form-wrap p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
    });

    // Landing Page Form Block
    let landingPageFromArr = gsap.utils.toArray('.landing-page-form-block'); 
    landingPageFromArr.forEach((lpfb, i) => {
      let lpfbtl = gsap.timeline({
        scrollTrigger: {
          trigger: lpfbtl,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      lpfbtl.to(lpfb.querySelector('h1'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      lpfbtl.to(lpfb.querySelectorAll('p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      lpfbtl.to(lpfb.querySelector('.form-wrap'), {opacity: 1, duration: 1, ease: 'power4.out'}, '-=0.95')
      lpfbtl.to(lpfb.querySelectorAll('.form-wrap p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
    });

    // Split
    let splitArr = gsap.utils.toArray('.fifty-split'); 
    splitArr.forEach((sp, i) => {
      let sptl = gsap.timeline({
        scrollTrigger: {
          trigger: sp,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      sptl.to(sp.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      sptl.to(sp.querySelector('img'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      sptl.to(sp.querySelectorAll('h3'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      sptl.to(sp.querySelectorAll('p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      sptl.to(sp.querySelectorAll('a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
    });

    // Logo Block
    let lbArr = gsap.utils.toArray('.logo-block'); 
    lbArr.forEach((lb, i) => {
      let lbtl = gsap.timeline({
        scrollTrigger: {
          trigger: lb,
          start: 'top +=100%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      lbtl.to(lb.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      lbtl.to(lb.querySelectorAll('.logo'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1}, '-=0.95')
    });

    // Team Feed
    let tfArr = gsap.utils.toArray('.team-feed'); 
    tfArr.forEach((tf, i) => {
      let tftl = gsap.timeline({
        scrollTrigger: {
          trigger: tf,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      tftl.to(tf.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      tftl.to(tf.querySelectorAll('.profile'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1}, '-=0.95')
    });

    // News Feed
    let nfArr = gsap.utils.toArray('.news-feed'); 
    nfArr.forEach((nf, i) => {
      let nftl = gsap.timeline({
        scrollTrigger: {
          trigger: nf,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      nftl.to(nf.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      nftl.to(nf.querySelectorAll('.news'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1}, '-=0.95')
      nftl.to(nf.querySelectorAll('a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
    });

    // Logo Grid
    let lgArr = gsap.utils.toArray('.outer__logo_grid'); 
    lgArr.forEach((lg, i) => {
      let lgtl = gsap.timeline({
        scrollTrigger: {
          trigger: lg,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      lgtl.to(lg.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(lg.querySelectorAll('p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      .to(lg.querySelectorAll('.logo'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.2}, '-=0.95')
    });

    // Grid Card
    let gcArr = gsap.utils.toArray('.outer__card_grid'); 
    gcArr.forEach((gc, i) => {
      let gctl = gsap.timeline({
        scrollTrigger: {
          trigger: gc,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      gctl.to(gc.querySelectorAll('.card_grid__item'), {opacity: 1, duration: 1, ease: 'power4.out', stagger: 0.1})
    });

     // Headline List
     let hllArr = gsap.utils.toArray('.headline-list'); 
     hllArr.forEach((hl, i) => {
      let hlltl = gsap.timeline({
        scrollTrigger: {
          trigger: hl,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      hlltl.to(hl.querySelectorAll('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(hl.querySelectorAll('.outer'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1}, '-=0.95')
    });

    // Video Marquee
    let vmArr = gsap.utils.toArray('.video-marquee'); 
    vmArr.forEach((vm, i) => {
      let vmtl = gsap.timeline({
        scrollTrigger: {
          trigger: vm,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      vmtl.to(vm.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(vm.querySelectorAll('p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      .to(vm.querySelectorAll('a'), {opacity: 1, y: 0, duration: 0.5, ease: 'power4.out'}, '-=0.95')
    });

    // Split Steps
    let ssArr = gsap.utils.toArray('.split-steps'); 
    ssArr.forEach((ss, i) => {
      let sstl = gsap.timeline({
        scrollTrigger: {
          trigger: ss,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      sstl.to(ss.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(ss.querySelectorAll('.cols'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1}, '-=0.95')
      .to(ss.querySelector('.grid-decoration'), {height: '450px', maxWidth: '375px', duration: 1, ease: 'power4.out'}, '-=0.95')
    });


    gsap.utils.toArray('.step').forEach(step => {
      ScrollTrigger.create({
        trigger: step,
        start: 'center 70%',
        end: 'center top',
        toggleClass: 'active',
        onRefresh: self => self.progress === 1 && self.animation.progress(1),
      });
    });

    // Two Col Boxes
    let twbArr = gsap.utils.toArray('.two-col-boxes'); 
    twbArr.forEach((twb, i) => {
      let twbtl = gsap.timeline({
        scrollTrigger: {
          trigger: twb,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      twbtl.to(twb.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(twb.querySelectorAll('.box'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: {each: 0.3}}, '-=0.95')
    });

    
    // Pinned Tabs
    if ($('body').hasClass('trust-and-safety')) {
      const paths = document.querySelectorAll('.anim-paths')
      gsap.set(paths, { visibility: 'visible' })

      let thepanels = document.querySelector('.pinned-tabs .tab-panels').offsetHeight * 4
      let pdttl = gsap.timeline({
        scrollTrigger: {
          trigger: '.pinned-nav',
          scrub: true,
          start: 'top top',
          end: '+='+thepanels,
          pin: true,
          pinSpacing: false,
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      let tpanels = gsap.utils.toArray('.pinned-tabs .tab-panels')
      tpanels.forEach((pn, i) => {
        let pdctl = gsap.timeline({
          scrollTrigger: {
            trigger: pn,
            start: 'top center+=250px',
            scrub: true,
            onRefresh: self => self.progress === 1 && self.animation.progress(1),
          },
        });  
        pdctl.to(pn.querySelectorAll('h2'), { opacity: 1, y: 0, duration: 0.3 }, '-=1.2')
        .to(pn.querySelectorAll('p'), { opacity: 1, y: 0, duration: 0.3 }, '-=1.2')
        .to(pn.querySelectorAll('a'), { opacity: 1, y: 0, duration: 0.3 }, '-=1.2')
        .fromTo(pn.querySelectorAll('.mask'), {drawSVG:"100% 0%"}, {duration: 1, drawSVG:"100% 100%"}, '-=1.3')
        .fromTo(pn.querySelectorAll('.anim-paths circle'), {drawSVG:"100% 100%"}, {duration: 0.5, delay: 0.8, drawSVG:"100% 0%"}, '-=1.5')
      });
    }


     // Pinned Marquee

     let pstl = gsap.timeline({
      scrollTrigger: {
        trigger: '.pinned-marquee',
        scrub: true,
        start:"top top",
        pin: true,
        pinSpacing: true,
        onRefresh: self => self.progress === 1 && self.animation.progress(1),
      },
    });
     pstl.to('.pinned-marquee h3', { opacity: 1, y: 0, duration: 1.5 })
     .to('.pinned-marquee p', { opacity: 1, y: 0,  duration: 1.5 })
     .to('.pinned-marquee .blue-overlay', { y: '-100%', duration: 1.5 })
     .to('.pinned-marquee h3', { opacity: 0, y: -20, duration: 1.5 })
     .to('.pinned-marquee p', { opacity: 0, y: -20,  duration: 1.5 })
     .to('.pinned-marquee h2', { opacity: 1, y: 0, duration: 1.5 })


     // Pinned Slider
     let fadein = gsap.utils.toArray('.pans')
     fadein.forEach((item, index) => {
      let pstll = gsap.timeline({
        scrollTrigger: {
          trigger: item,
          start:"top +=300",
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      });
      pstll.to(item.querySelectorAll('h2'), { opacity: 1, duration: 1.5 })
      .to(item.querySelectorAll('p'), { opacity: 1, duration: 1.5, stagger: {each: 0.3} }, '-=1.3')
    });

     // Pinned Slider Extended
     let fadeinAlt = gsap.utils.toArray('.extended .pans')
     fadeinAlt.forEach((it, index) => {
      let pstllalt = gsap.timeline({
        scrollTrigger: {
          trigger: it,
          start:"top +=300",
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      });
      pstllalt.to(it.querySelectorAll('h3'), { opacity: 1, duration: 1.5 })
      .to(it.querySelectorAll('p'), { opacity: 1, duration: 1.5 }, '-=1.3')
      .to(it.querySelectorAll('.logo'), { opacity: 1, duration: 1.5, stagger: {each: 0.2} }, '-=1.3')
    });

     $.fn.isInViewport = function() {
      var elementTop = $(this).offset().top;
      var elementBottom = elementTop + $(this).outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop + 550  && elementTop + 450 < viewportBottom;
    };

    if ($('body').hasClass('why-truepic')) {

      $(window).on('resize scroll', function() {

        if ($('.pinned-slider').isInViewport()) {
          $('.indicator-wrap').addClass('active');
        } else {
          $('.indicator-wrap').removeClass('active');
        }

        $('.pans .p-box').each(function() {
          var activePane = $(this).attr('id');
          if ($(this).isInViewport()) {
            $('#ind-' + activePane).addClass('active');
          } else {
            $('#ind-' + activePane).removeClass('active');
          }
        });
      });
    }

    // Map Fun
    $('.inactive-hs').on('click', function() {
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
      let actID = $(this).attr('id').replace('hs_', '');
      $(`#hs-text-${actID}`).addClass('active');
      $(`#hs-text-${actID}`).siblings().removeClass('active');
      $(`.active-hotspot-${actID}`).addClass('active');
      $(`.active-hotspot-${actID}`).siblings().removeClass('active');
    });

    // Timeline 
    let tlcArr = gsap.utils.toArray('.timeline'); 
    tlcArr.forEach((tlc, i) => {
      let tltl = gsap.timeline({
        scrollTrigger: {
          trigger: tlc,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      tltl.to(tlc.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      tltl.to(tlc.querySelectorAll('.intro p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1}, '-=0.85')
      tltl.to(tlc.querySelectorAll('.box-1 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      tltl.to(tlc.querySelectorAll('.box-1 .divider'), {width: '100%', duration: 1, ease: 'power4.out'}, '-=0.75')
      tltl.to(tlc.querySelectorAll('.box-1 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.65')
      tltl.to(tlc.querySelectorAll('.box-2 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      tltl.to(tlc.querySelectorAll('.box-2 .divider'), {width: '100%', duration: 1, ease: 'power4.out'}, '-=0.75')
      tltl.to(tlc.querySelectorAll('.box-2 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.65')
      tltl.to(tlc.querySelectorAll('.box-3 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      tltl.to(tlc.querySelectorAll('.box-3 .divider'), {width: '100%', duration: 1, ease: 'power4.out'}, '-=0.75')
      tltl.to(tlc.querySelectorAll('.box-3 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.65')
      tltl.to(tlc.querySelectorAll('.box-4 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      tltl.to(tlc.querySelectorAll('.box-4 .divider'), {width: '100%', duration: 1, ease: 'power4.out'}, '-=0.75')
      tltl.to(tlc.querySelectorAll('.box-4 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.65')
    });

    // Buckets 
    let icbArr = gsap.utils.toArray('.icon-buckets'); 
    icbArr.forEach((icb, i) => {
      let icbtl = gsap.timeline({
        scrollTrigger: {
          trigger: icb,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      icbtl.to(icb.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      icbtl.to(icb.querySelectorAll('.intro p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.90')
      // icbtl.to(icb.querySelectorAll('.lower-shape'), {opacity: 1, x: 0, duration: 1, ease: 'power4.out'}, '-=0.90')
      // icbtl.to(icb.querySelectorAll('.upper-shape'), {opacity: 1, x: 0, duration: 1, ease: 'power4.out'}, '-=0.90')
      icbtl.to(icb.querySelectorAll('.box-1 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      icbtl.to(icb.querySelectorAll('.box-1 h3'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.83')
      icbtl.to(icb.querySelectorAll('.box-1 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
      icbtl.to(icb.querySelectorAll('.box-1 a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
      icbtl.to(icb.querySelectorAll('.box-2 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      icbtl.to(icb.querySelectorAll('.box-2 h3'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.83')
      icbtl.to(icb.querySelectorAll('.box-2 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
      icbtl.to(icb.querySelectorAll('.box-2 a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
      icbtl.to(icb.querySelectorAll('.box-3 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      icbtl.to(icb.querySelectorAll('.box-3 h3'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.83')
      icbtl.to(icb.querySelectorAll('.box-3 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
      icbtl.to(icb.querySelectorAll('.box-3 a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
      icbtl.to(icb.querySelectorAll('.box-4 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      icbtl.to(icb.querySelectorAll('.box-4 h3'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.83')
      icbtl.to(icb.querySelectorAll('.box-4 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
      icbtl.to(icb.querySelectorAll('.box-4 a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
    });

    // Icon Cards 
    let iccArr = gsap.utils.toArray('.icon-cards'); 
    iccArr.forEach((icc, i) => {
      let icctl = gsap.timeline({
        scrollTrigger: {
          trigger: icc,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      icctl.to(icc.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      icctl.to(icc.querySelectorAll('.intro p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.90')
      icctl.to(icc.querySelectorAll('.box'), {opacity: 1, x: 0, duration: 1, ease: 'power4.out', stagger: {each: 0.2}}, '-=0.85')
    });

    // Comps 
    let ctbbArr = gsap.utils.toArray('.comp-table'); 
    ctbbArr.forEach((ctb, i) => {
      let ctbtl = gsap.timeline({
        scrollTrigger: {
          trigger: ctb,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      ctbtl.to(ctb.querySelector('.intro h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      ctbtl.to(ctb.querySelector('.intro p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      ctbtl.to(ctb.querySelectorAll('.box-1 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      ctbtl.to(ctb.querySelectorAll('.box-1 h3'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
      ctbtl.to(ctb.querySelectorAll('.box-1 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.75')
      ctbtl.to(ctb.querySelectorAll('.box-2 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      ctbtl.to(ctb.querySelectorAll('.box-2 h3'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
      ctbtl.to(ctb.querySelectorAll('.box-2 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.75')
      ctbtl.to(ctb.querySelectorAll('.box-3 .icon'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.85')
      ctbtl.to(ctb.querySelectorAll('.box-3 h3'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.80')
      ctbtl.to(ctb.querySelectorAll('.box-3 p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.75')
    });

     // Feature Grid Block
     let fgbArr = gsap.utils.toArray('.outer__features_grid'); 
     fgbArr.forEach((fgb, i) => {
      let fgbtl = gsap.timeline({
        scrollTrigger: {
          trigger: fgb,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      fgbtl.to(fgb.querySelector('h2'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      .to(fgb.querySelectorAll('p'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      .to(fgb.querySelectorAll('.features_grid__item'), { opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: {each: 0.3}}, '-=0.95')
    });

    // Product Split
    let prodsplitArr = gsap.utils.toArray('.product-split'); 
    prodsplitArr.forEach((psp, i) => {
      let psptl = gsap.timeline({
        scrollTrigger: {
          trigger: psp,
          start: 'top +=60%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      psptl.to(psp.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      psptl.to(psp.querySelectorAll('p'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      psptl.to(psp.querySelectorAll('.box'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.3}, '-=0.90')
    });

    // Flexible Column Block
    let fcbArr = gsap.utils.toArray('.flexible-column-block'); 
    fcbArr.forEach((fcb, i) => {
      let fcbtl = gsap.timeline({
        scrollTrigger: {
          trigger: fcb,
          start: 'top +=90%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      // fcbtl.to(fcb.querySelector('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
      // fcbtl.to(fcb.querySelectorAll('.news'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1}, '-=0.95')
      fcbtl.to(fcb.querySelectorAll('.columns'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1})
      fcbtl.to(fcb.querySelectorAll('a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
      
     
    });

    // Savings Calculator Block
    let scbArr = gsap.utils.toArray('.savings-calculator-block'); 
    scbArr.forEach((scb, i) => {
      let scbtl = gsap.timeline({
        scrollTrigger: {
          trigger: scb,
          start: 'top +=80%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      scbtl.to(scb.querySelectorAll('a'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'}, '-=0.95')
    });

    // FAQs Block
    let faqbArr = gsap.utils.toArray('.faqs-block'); 
    faqbArr.forEach((faqb, i) => {
      let faqbtl = gsap.timeline({
        scrollTrigger: {
          trigger: faqb,
          start: 'top +=80%',
          onRefresh: self => self.progress === 1 && self.animation.progress(1),
        },
      })
      faqbtl.to(faqb.querySelectorAll('h2'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1})
      faqbtl.to(faqb.querySelectorAll('.accordion'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out', stagger: 0.1})
      faqbtl.to(faqb.querySelectorAll('h3'), {opacity: 1, y: 0, duration: 1, ease: 'power4.out'})
    });

    $( ".copy-to-clipboard" ).on( "click", function() {
      var copyText = $(this).data( "copyText" );
      var copyScript = $(this).data( "copyScript" );
      var toastMessage = $(this).data( "toastMessage" );
      
      if (copyScript)
        copyText = '<script type="module" src="https://display.truepic.com/truepic_display.es.js"></script>';
      else
        copyText = copyText == 'window.location.href' ? window.location.href : copyText;

      navigator.clipboard.writeText(copyText);

      Toastify({
        text: toastMessage,
        duration: 3000,
        position: "center",
        className: "toastinfo",
      }).showToast();
    });

    $( "#embedVideoModalCTA" ).on( "click", function() {
      var copyText = $('#embedVideoCode').val();
      var toastMessage = $(this).data( "toastMessage" );
      navigator.clipboard.writeText(copyText);

      Toastify({
        text: toastMessage,
        duration: 3000,
        position: "center",
      }).showToast();
    });


    //var icon = '<button class="close-button" data-close aria-label="Close modal" type="button"><span aria-hidden="true">&times;</span></button>';
    //$('.reveal-overlay').append(icon);    

    function heroTransitionsFunction() {
      var $active = $('#hero-transitioner .active');
      var $next = ($active.next().length > 0) ? $active.next() : $('#hero-transitioner img:first');
      $next.css('z-index',2);
      $active.fadeOut(1000,function(){
        $active.css('z-index',1).show().removeClass('active');
        $next.css('z-index',3).addClass('active');
        setTimeout(heroTransitionsFunction, 2000);
      });
    }

    setTimeout(heroTransitionsFunction, 2000);

    // Savings Calculator
    //http://davidwalsh.name/javascript-debounce-function
    function debounce(func, wait, immediate) {
      var timeout;
      return function() {
          var context = this, args = arguments;
          var later = function() {
              timeout = null;
              if (!immediate) func.apply(context, args);
          };
          var callNow = immediate && !timeout;
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
          if (callNow) func.apply(context, args);
      }
    }

    $('#calculate_savings').on('click', function() {
      if ($('input[name="cost_per_inspection"]').val() != '' && $('input[name="num_of_inspections"]').val() != '') {
        calcSavings();
      }
    });

    $('input[name="cost_per_inspection"], input[name="num_of_inspections"]').on('keyup', debounce(function() {
      if ($('input[name="cost_per_inspection"]').val() != '' && $('input[name="num_of_inspections"]').val() != '' && !$("#calculate_savings").is(":visible")) {
        calcSavings();
      }
    }, 250));

    function calcSavings( cost_basis = 25) {
      var average = $('input[name="cost_per_inspection"]').val();
      var number = $('input[name="num_of_inspections"]').val();

      var monthlySavings = average > cost_basis ? number * (average - cost_basis) : 0;
      
      $('#calculate_savings').hide();

      if (number >= 500) {
        $('.savings-calculator-results-block').hide();
        $('.savings-calculator-enterprise-results-block').show();
      } else {
        var annualSavings = monthlySavings * 12;

        monthlySavings = (Math.round(monthlySavings * 100) / 100).toFixed(2);
        annualSavings = (Math.round(annualSavings * 100) / 100).toFixed(2);

        $('#annual_savings').html("$" + annualSavings.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        $('#monthly_savings').html("$" + monthlySavings.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","));
        
        $('.savings-calculator-enterprise-results-block').hide();
        $('.savings-calculator-results-block').show();
      }
    }

    $('input[name="num_of_inspections"], input[name="cost_per_inspection"]').on('keyup', debounce(function() {
      var average = $('input[name="cost_per_inspection"]').val();
      var number = $('input[name="num_of_inspections"]').val();
      var _nonce = $('input[name="_nonce"]').val();

      if (average === '' || number === '' || reveal === null || reveal.company === null) {
        return
      }

      let company = reveal.company;
      var companyname = company.name;
      var companydomain = company.domain;
      
      var data = {
        companyname,
        companydomain: "www." + companydomain,
        number,
        average,
        _nonce,
      }
      
      jQuery.post('/wp-json/calculator/v1/alert', jQuery.param(data), function(data) {
        console.log("response", data);
      });

    }, 1000))
    // End Savings Calculator
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js